import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { Button } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import DocumentoRelacionadoForm from './DocumentoRelacionadoForm';
import DocumentosRelacionadosList from './DocumentosRelacionadosList';
import DecimalForGlobals from '../../../support/impuestos/DecimalForGlobals';

const DocumentoManager = (props) => {
  const [data, setData] = useState([]);
  const [editing, setEditing] = useState();
  const [showForm, setShowForm] = useState(true);

  useEffect(() => {
    if (props.editing) {
      const { DoctoRelacionado = [] } = props.data ?? {};
      handleOnListChange(DoctoRelacionado);
      setShowForm(false);
    }
  }, [props.editing]); // eslint-disable-line

  const handleOnAdd = (value) => {
    const newState = [].concat(data, [
      {
        id: Uuid.v4(),
        ...value,
      },
    ]);

    handleOnListChange(newState);

    if (!!editing) {
      setEditing();
    }

    setShowForm(false);
  };

  const handleOnEdit = (item) => {
    setEditing(item);
    setShowForm(true);

    const newData = data.filter((value) => value.id !== item.id);

    handleOnListChange(newData);
  };

  const handleOnDelete = (item) => {
    const newData = data.filter((value) => value.id !== item.id);

    handleOnListChange(newData);
  };

  const handleOnShowForm = (event) => {
    setShowForm(true);
  };

  const handleOnListChange = (data) => {
    setData(data);

    let Monto = _.sumBy(data, (item) => {
      return parseFloat(item.ImpPagado);
    });

    Monto = Monto !== undefined ? DecimalForGlobals.make(Monto).toFixed() : undefined;

    props.onChange({ DoctoRelacionado: data, Monto });
  };

  const handleOnChange = (data) => {
    props.onChange({
      ...props.data,
      ...data,
    });
  };

  return (
    <>
      {!showForm && data.length > 0 && (
        <div className="py-2 mr-3">
          <p>¿Quieres relacionar un nuevo comprobante?</p>

          <Button variant="secondary"
            onClick={handleOnShowForm}
          >
            Agregar factura
          </Button>
        </div>
      )}

      {(!!showForm || data.length === 0) && (
        <div data-test-id="pagos-form">          
          <DocumentoRelacionadoForm
            data={editing}
            documentos={data}
            comprobante={props.comprobante}
            version={props.comprobante.Version}
            onAdd={handleOnAdd}
            onChange={handleOnChange}
          />
        </div>
      )}

      <div data-test-id="pagos-list">
        <DocumentosRelacionadosList
          onDelete={handleOnDelete}
          onEdit={handleOnEdit}
          data={data}
        />
      </div>
    </>
  );
};

export default DocumentoManager;
